<template>
  <form v-on:submit.prevent="proceed()" :class="[enabled ? 'orange' : 'grey', 'box left-box-sizing text-left']">
    <!-- box header -->
    <div class="header">
      <span :class="[enabled ? 'orange' : 'grey', 'step mx-2 mx-md-4']">2</span>
      <h2 :class="[enabled ? 'text-dark' : 'text-grey']">Review &amp; Pay</h2>
    </div>

    <!-- content -->
    <div v-if="enabled" class="content">
      <div class="px-3 px-lg-2">
        <div class="course-card d-flex justify-content-left align-items-center p-3">
          <img
            :src="course.image"
            alt="course image"
            height="50"
          >
          <div class="ml-3 mr-1 course-name">
            <b class="mb-2" style="font-size: 16px;">{{ course.name }}</b>
            <button @click="$emit('remove')" class="remove-button">
              Remove
            </button>
          </div>
          <div style="min-width: 58px;" class="ml-auto mb-auto">
            <b style="font-size: 14px; display: inline-block; min-width: 64px;">
              &#8377; {{ course.price.toLocaleString() }}/-
            </b>
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div v-if="enabled" class="footer">
      <div class="px-3 form">
        <input
          class="mx-sm-auto ml-md-auto mr-md-0"
          type="submit"
          value="Proceed To Payment"
          :disabled="isDisabled"
        >
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "Review",
  props: ["enabled", "course"],
  data() {
    return {
      isDisabled: false,
    }
  },
  methods: {
    proceed() {
      this.isDisabled = true;
      // console.log('proceed-to-buy');
      this.$emit('proceed-to-buy');
    }
  },
}
</script>

<style scoped>
  .course-name {
    display: flex;
    flex-direction: column;
    justify-content: left;
  }

  .remove-button {
    background: inherit;
    border: none;
    padding: 0;
    font-size: 12px;
    color: #E63638;
    display: flex;
    justify-content: left;
    outline: none;
  }
  .remove-button:focus {
    border: none;
  }
  .remove-button:hover {
    cursor: pointer;
  }

  .box > .header > .step {
    color:#fff;
    border-radius: 1000px;
    background: #f36f2e;
    height: 36px;
    width: 36px;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  .box > .header > .step.grey {
    background: #c0c0c0;
    border: 2px solid #c0c0c0;
  }

  .box > .header > .step.orange {
    background: #f36f2e;
  }
  
  .box > .header > .text-grey {
    color: #909090 !important;
  }

  .box > .content {
    overflow: hidden;
  }

  /* .box > .content .course-card {

  } */

  .input-group {
    position: relative;
  }

  .input-group > .label {
    position: absolute;
  }
  .input-group > .text:hover, .label:hover {
    cursor: pointer;
  }

  .text {
    outline: none;
    padding: 10px;
    border-radius: 4px;
    border: solid 1px #A0A0A0;
    /* width: 100%; */
  }

  .label {
    padding: 11px;
    top: 0;
    left: 0;
    transition: all 0.5s;
    color: #A0A0A0;
    white-space: nowrap;
  }

  .text:focus {
    border: solid 1px #F36F2E;
  }

  .text:focus ~ .label {
    padding: 0 4px;
    font-size: 0.8rem;
    top: -0.4rem;
    left: 0.4rem;
    background: #fff;
    color: #F36F2E;
    
    transition: all 0.5s;
  }

  .filled {
    padding: 0 4px;
    font-size: 0.8rem;
    top: -0.4rem;
    left: 0.4rem;
    background: #fff;
  }
</style>